/** @fileoverview @suppress {undefinedVars} */

import * as exports from '../generators/python.js';
$['__chunk_python'] = exports;
